import { FinanceApplicationsMerchantReportModel } from '@/shared/models/finance-applications-merchant-report.model';
import { FinanceApplicationsMerchantReportUiModel } from '@/shared/ui-models/finance-applications-merchant-report.ui-model';

/**
 * The report can arrive without a merchant name: applications with no finance merchant group under
 * a null id, a deleted merchant fails its lookup, and `companyName` is sometimes a plain string
 * rather than a localized object. Normalize all of it so the UI can rely on `{ ar, en }` existing.
 */
function mapMerchantName(
  financialMerchantName: FinanceApplicationsMerchantReportModel['financialMerchantName']
): { ar: string; en: string } {
  if (!financialMerchantName) {
    return { ar: '', en: '' };
  }

  if (typeof financialMerchantName === 'string') {
    return { ar: financialMerchantName, en: financialMerchantName };
  }

  // Fall back to the other language rather than showing an empty slice label.
  return {
    ar: financialMerchantName.ar || financialMerchantName.en || '',
    en: financialMerchantName.en || financialMerchantName.ar || ''
  };
}

function mapToUi(
  financeApplicationsMerchantReport: FinanceApplicationsMerchantReportModel
): FinanceApplicationsMerchantReportUiModel {
  return {
    ...financeApplicationsMerchantReport,
    applicationsCount: financeApplicationsMerchantReport.applicationsCount ?? 0,
    financedAmount: financeApplicationsMerchantReport.financedAmount ?? 0,
    financialMerchantId: financeApplicationsMerchantReport.financialMerchantId ?? '',
    financialMerchantImageUrl: financeApplicationsMerchantReport.financialMerchantImageUrl ?? '',
    financialMerchantName: mapMerchantName(financeApplicationsMerchantReport.financialMerchantName)
  };
}

function mapToUiList(
  financeApplicationsMerchantReportList: FinanceApplicationsMerchantReportModel[]
): FinanceApplicationsMerchantReportUiModel[] {
  return (financeApplicationsMerchantReportList || []).map(mapToUi);
}

const financeApplicationsMerchantReportMapper = { mapToUi, mapToUiList };

export default financeApplicationsMerchantReportMapper;
